import { defineComponent, useTemplateRef, useSlots, computed, ref, onMounted, createElementBlock, openBlock, normalizeClass, createCommentVNode, createBlock, Fragment, renderSlot, toDisplayString, withCtx, resolveDynamicComponent, unref, createElementVNode, createTextVNode } from 'vue';
import { useBreakpoints } from './basler-components.es378.js';
import _sfc_main$2 from './basler-components.es72.js';
import _sfc_main$3 from './basler-components.es87.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es197.js';
/* empty css                        */
import { BREAKPOINTS } from './basler-components.es396.js';

const _hoisted_1 = {
  key: 0,
  class: "product-list-layout__filter"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = { class: "product-list-layout__meta-bar" };
const _hoisted_4 = { class: "product-list-layout__meta-bar-info" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { class: "product-list-layout__meta-bar-actions" };
const _hoisted_7 = {
  key: 2,
  class: "product-list-layout__filter-tags"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductListLayout",
  props: {
    showFilter: { type: Boolean, default: true },
    resultsText: { default: "" },
    contentHeadingId: {},
    contentHeading: {},
    filtersSkipBtnText: { default: "Click to skip" },
    filtersOpenBtnText: { default: "Show filters" },
    filtersModalTitle: { default: "Filters" },
    filtersModalCloseIconText: { default: "Close modal" },
    filtersModalApplyBtnText: { default: "Show results" },
    isLoading: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const contentElementRef = useTemplateRef("contentElement");
    const contentHeadingId = props.contentHeadingId || Date.now().toString(36) + Math.random().toString(36).substring(2);
    const slots = useSlots();
    const showFilterTags = computed(() => {
      return !!slots.filterTags;
    });
    const breakpoints = useBreakpoints(BREAKPOINTS);
    const isMounted = ref(false);
    const isMobile = computed(() => {
      if (!isMounted.value) {
        return false;
      }
      return breakpoints.smaller("lg").value;
    });
    const showFilterModal = ref(false);
    const onFiltersSkip = () => {
      if (contentElementRef.value) {
        contentElementRef.value.tabIndex = -1;
        contentElementRef.value.focus();
      }
    };
    onMounted(() => {
      isMounted.value = true;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["product-list-layout", { "product-list-layout--no-filter": !_ctx.showFilter }])
      }, [
        _ctx.showFilter ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          !isMobile.value ? (openBlock(), createElementBlock("aside", _hoisted_1, [
            _ctx.filtersSkipBtnText && _ctx.contentHeading ? (openBlock(), createElementBlock("button", {
              key: 0,
              type: "button",
              class: "button button--secondary product-list-layout__skip-btn visually-hidden-focusable",
              tabindex: "0",
              onClick: onFiltersSkip
            }, toDisplayString(_ctx.filtersSkipBtnText), 1)) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "filter")
          ])) : (openBlock(), createBlock(_sfc_main$1, {
            key: 1,
            modelValue: showFilterModal.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => showFilterModal.value = $event),
            title: _ctx.filtersModalTitle,
            "close-icon-text": _ctx.filtersModalCloseIconText,
            "apply-text": _ctx.filtersModalApplyBtnText,
            "click-to-close": true,
            "esc-to-close": true,
            "is-full-screen": true,
            onConfirm: _cache[1] || (_cache[1] = ($event) => showFilterModal.value = false),
            onAbort: _cache[2] || (_cache[2] = ($event) => showFilterModal.value = false)
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "filter")
            ]),
            _: 3
          }, 8, ["modelValue", "title", "close-icon-text", "apply-text"]))
        ], 64)) : createCommentVNode("", true),
        (openBlock(), createBlock(resolveDynamicComponent(_ctx.contentHeading ? "section" : "div"), {
          ref: "contentElement",
          class: "product-list-layout__content",
          "aria-labelledby": _ctx.contentHeading ? unref(contentHeadingId) : void 0
        }, {
          default: withCtx(() => [
            _ctx.contentHeading ? (openBlock(), createElementBlock("h2", {
              key: 0,
              id: unref(contentHeadingId),
              class: "visually-hidden"
            }, toDisplayString(_ctx.contentHeading), 9, _hoisted_2)) : createCommentVNode("", true),
            isMobile.value ? (openBlock(), createBlock(_sfc_main$2, {
              key: 1,
              class: "product-list-layout__btn-filter-modal",
              tag: "button",
              "style-type": "secondary",
              "icon-type": "icon-left",
              "icon-name": "configurator",
              onClick: _cache[3] || (_cache[3] = ($event) => showFilterModal.value = true)
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.filtersOpenBtnText), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_3, [
              createElementVNode("div", _hoisted_4, [
                _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$3, {
                  key: 0,
                  class: "product-list-layout__loading-text"
                })) : (openBlock(), createElementBlock("span", {
                  key: 1,
                  innerHTML: _ctx.resultsText
                }, null, 8, _hoisted_5))
              ]),
              createElementVNode("div", _hoisted_6, [
                renderSlot(_ctx.$slots, "actions")
              ])
            ]),
            showFilterTags.value ? (openBlock(), createElementBlock("div", _hoisted_7, [
              renderSlot(_ctx.$slots, "filterTags")
            ])) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "list")
          ]),
          _: 3
        }, 8, ["aria-labelledby"]))
      ], 2);
    };
  }
});

export { _sfc_main as default };
